var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 8,
    fill: "#24275C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C14.2063 24 16 22.2063 16 20C16 17.7937 14.2063 16 12 16C9.79375 16 8 17.7937 8 20C8 22.2063 9.79375 24 12 24ZM40 24C42.2062 24 44 22.2063 44 20C44 17.7937 42.2062 16 40 16C37.7938 16 36 17.7937 36 20C36 22.2063 37.7938 24 40 24ZM42 26H38C36.9 26 35.9062 26.4438 35.1812 27.1625C37.7 28.5438 39.4875 31.0375 39.875 34H44C45.1063 34 46 33.1063 46 32V30C46 27.7937 44.2062 26 42 26ZM26 26C29.8687 26 33 22.8687 33 19C33 15.1312 29.8687 12 26 12C22.1313 12 19 15.1312 19 19C19 22.8687 22.1313 26 26 26ZM30.8 28H30.2812C28.9813 28.625 27.5375 29 26 29C24.4625 29 23.025 28.625 21.7188 28H21.2C17.225 28 14 31.225 14 35.2V37C14 38.6562 15.3438 40 17 40H35C36.6562 40 38 38.6562 38 37V35.2C38 31.225 34.775 28 30.8 28ZM16.8188 27.1625C16.0938 26.4438 15.1 26 14 26H10C7.79375 26 6 27.7937 6 30V32C6 33.1063 6.89375 34 8 34H12.1188C12.5125 31.0375 14.3 28.5438 16.8188 27.1625Z",
    fill: "#EAD7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19C33 22.8687 29.8687 26 26 26C22.1313 26 19 22.8687 19 19C19 15.1312 22.1313 12 26 12C29.8687 12 33 15.1312 33 19Z",
    fill: "#EAD7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 26H38C36.9 26 35.9062 26.4438 35.1812 27.1625C37.7 28.5438 39.4875 31.0375 39.875 34H44C45.1063 34 46 33.1062 46 32V30C46 27.7937 44.2062 26 42 26ZM30.8 28H30.2812C28.9813 28.625 27.5375 29 26 29C24.4625 29 23.025 28.625 21.7188 28H21.2C17.225 28 14 31.225 14 35.2V37C14 38.6562 15.3438 40 17 40H35C36.6562 40 38 38.6562 38 37V35.2C38 31.225 34.775 28 30.8 28ZM16.8188 27.1625C16.0938 26.4438 15.1 26 14 26H10C7.79375 26 6 27.7937 6 30V32C6 33.1062 6.89375 34 8 34H12.1188C12.5125 31.0375 14.3 28.5438 16.8188 27.1625Z",
    fill: "#8C30F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 34,
    width: 5,
    height: 3,
    rx: 1.5,
    fill: "#2EC5CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.4f7c8d8214863aae33726d253ab9e152.svg";
export { ForwardRef as ReactComponent };